import type { ThemeTypes } from '@/types/themeTypes/ThemeType';

/**
 * Dark theme — VoIP Customer Portal.
 * Surfaces use a deep navy tint (matches the brand) rather than neutral grey.
 * Brand colors are brightened for AAA contrast on dark surfaces.
 */
const DarkPurpleTheme: ThemeTypes = {
  name: 'DarkPurpleTheme',
  dark: true,
  variables: {
    'border-color': '#1e3a5f',
    'high-opacity': 1
  },
  colors: {
    // ---- Brand ----
    primary: '#4a8fd9',          // brightened navy for dark mode
    secondary: '#7baee6',
    accent: '#ff4d5e',           // brand red, brightened for dark surfaces

    // ---- Semantic state ----
    info: '#38bdf8',
    success: '#34d399',
    warning: '#fbbf24',
    error: '#f87171',

    // ---- Surfaces (navy-tinted, not neutral grey) ----
    background: '#061427',        // deepest navy — app background
    surface: '#0b1d36',           // cards
    'surface-bright': '#15294a',
    'surface-light': '#0f223d',
    'surface-variant': '#15294a',
    'on-surface': '#e2e8f0',
    'on-surface-variant': '#94a3b8',
    'on-primary': '#ffffff',
    'on-secondary': '#ffffff',

    // ---- Tinted backgrounds ----
    lightprimary: '#0f2a4d',
    lightsecondary: '#0f2a4d',
    lightsuccess: '#064e3b',
    lighterror: '#7f1d1d',
    lightwarning: '#78350f',
    lightinfo: '#0c4a6e',
    lightaccent: '#3a0d12',

    // ---- Pressed variants ----
    darkprimary: '#6ba5e6',
    darksecondary: '#9cc6ef',
    darkinfo: '#0ea5e9',
    darksuccess: '#10b981',
    darkwarning: '#f59e0b',
    darkerror: '#ef4444',
    darkaccent: '#ff7a87',

    // ---- Text ----
    darkText: '#e2e8f0',
    lightText: '#94a3b8',

    // ---- Borders & inputs ----
    borderLight: '#1e3a5f',
    inputBorder: '#334155',
    containerBg: '#0a1a2e',
    'border-opacity': '0.6',

    // ---- Social ----
    facebook: '#1877f2',
    twitter: '#1da1f2',
    linkedin: '#0a66c2',

    // ---- Greys ----
    gray100: '#15294a',
    gray200: '#1a3055',
    gray300: '#1e3a5f',
    gray400: '#475569',
    gray500: '#64748b',
    gray700: '#94a3b8',
    gray900: '#e2e8f0',

    primary200: '#052a4d',
    secondary200: '#143f63'
  }
};

export { DarkPurpleTheme };
